import React from 'react';

import { NcAlert } from '../NcAlert';

export type NcPaymentMethodSameDayBannerT = React.FC;

export const NcPaymentMethodSameDayBanner: NcPaymentMethodSameDayBannerT = () => {
  return (
    <NcAlert
      dismissible={false}
      variant="info"
    >
      For same-day payments, select debit card.
    </NcAlert>
  );
};
